var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"n8n-spinner"},[(_vm.type === 'ring')?_c('div',{staticClass:"lds-ring"},[_c('div'),_c('div'),_c('div'),_c('div')]):_c('n8n-icon',{attrs:{"icon":"spinner","size":_vm.size,"spin":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }